export const normalizeURL = (plainText) => { 
    const [ baseUrl, docParam ] = plainText.split('?doc=');

    const parts = docParam.split('/');
    const filename = parts.pop();

    const encodedFilename = encodeURIComponent(filename);
    const encodedDocPath = [...parts, encodedFilename].join('/');

    return `${baseUrl}?doc=${encodedDocPath}`;
}